import React from "react";
import videoSource from "../resources/videos/NY-pages.mp4";
const BackGroundVideo = () => {
  return (
    <video
      autoPlay
      loop
      muted
      style={{
        position: "fixed",
        right: 0,
        bottom: 0,
        minWidth: "100%",
        minHeight: "100%",
        objectFit: "cover",
        zIndex: -1,
      }}
    >
      <source src={videoSource} type="video/mp4" />
      Your browser does not support the video tag.
    </video>

  );
};

export default BackGroundVideo;
